import { useState } from 'react';
import {
  Container,
  Anchor,
  rem,
  Text,
  Group,
  Stack,
  Table,
  Button,
  TextInput,
  ActionIcon,
  Skeleton,
} from '@mantine/core';
import { IconChevronLeft, IconTrash, IconPlus } from '@tabler/icons-react';
import { usePaymentMethods, useCreatePaymentMethod, useDeletePaymentMethod } from '@api/paymentMethods';
import { titleCase } from '@utils';

function PaymentMethodsPage() {
  const { data, isFetching } = usePaymentMethods();
  const { mutate: create, isLoading: isCreating } = useCreatePaymentMethod();
  const { mutate: remove } = useDeletePaymentMethod();
  const [newName, setNewName] = useState('');

  const handleCreate = () => {
    const trimmed = newName.trim();
    if (!trimmed) return;
    create({ name: trimmed }, { onSuccess: () => setNewName('') });
  };

  const rows = data?.data.map((pm) => (
    <Table.Tr key={pm.id}>
      <Table.Td>{titleCase(pm.name)}</Table.Td>
      <Table.Td>
        <Group justify="flex-end">
          <ActionIcon
            color="red"
            variant="subtle"
            onClick={() => remove({ id: pm.id })}
            title="Eliminar"
          >
            <IconTrash style={{ width: rem(16), height: rem(16) }} />
          </ActionIcon>
        </Group>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Container fluid>
      <Group>
        <Anchor href="/configuracion" underline="never" c="dimmed" fw={700}>
          <Group gap={4}>
            <IconChevronLeft style={{ width: rem(20), height: rem(20) }} />
            Configuración
          </Group>
        </Anchor>
      </Group>
      <Text fz={28} fw={700} mt={4}>
        Métodos de pago
      </Text>
      <Text fz={14} c="dimmed" mt={5}>
        Los métodos de pago disponibles para registrar cómo se pagan los documentos.
      </Text>

      <Stack maw={600} mt={30}>
        <Group gap={8} align="flex-end">
          <TextInput
            label="Nuevo método de pago"
            placeholder="Ej: Transferencia bancaria"
            value={newName}
            onChange={(e) => setNewName(e.currentTarget.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
            style={{ flex: 1 }}
          />
          <Button
            leftSection={<IconPlus style={{ width: rem(16), height: rem(16) }} />}
            onClick={handleCreate}
            loading={isCreating}
            disabled={!newName.trim()}
          >
            Agregar
          </Button>
        </Group>

        {isFetching ? (
          <Skeleton height={120} />
        ) : (
          <Table horizontalSpacing="md" verticalSpacing="sm" withTableBorder highlightOnHover>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Nombre</Table.Th>
                <Table.Th />
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {(rows ?? []).length > 0 ? (
                rows
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={2} c="dimmed">
                    No hay métodos de pago configurados
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        )}
      </Stack>
    </Container>
  );
}

export default PaymentMethodsPage;
